// Feriados Nacionais do Brasil e Feriados Judaicos (Yom Tov)

// Feriados fixos brasileiros
export const BRAZILIAN_FIXED_HOLIDAYS = {
  '01-01': 'Confraternização Universal',
  '04-21': 'Tiradentes',
  '05-01': 'Dia do Trabalho',
  '09-07': 'Independência do Brasil',
  '10-12': 'Nossa Senhora Aparecida',
  '11-02': 'Finados',
  '11-15': 'Proclamação da República',
  '12-25': 'Natal'
};

// Feriados móveis brasileiros (calculados por ano)
// Baseados na Páscoa (Domingo de Páscoa)
export const getBrazilianMobileHolidays = (year) => {
  const easter = calculateEaster(year);
  
  return {
    [formatDate(addDays(easter, -47))]: 'Carnaval',
    [formatDate(addDays(easter, -46))]: 'Carnaval',
    [formatDate(addDays(easter, -2))]: 'Sexta-feira Santa',
    [formatDate(easter)]: 'Páscoa',
    [formatDate(addDays(easter, 60))]: 'Corpus Christi'
  };
};

// Feriados Judaicos (Yom Tov) - apenas os dias principais
// Datas variam conforme o calendário lunar hebraico
export const JEWISH_HOLIDAYS = {
  // 2025
  2025: {
    '04-13': 'Pessach (1º dia)',
    '04-14': 'Pessach (2º dia)',
    '04-19': 'Pessach (7º dia)',
    '04-20': 'Pessach (8º dia)',
    '06-02': 'Shavuot (1º dia)',
    '06-03': 'Shavuot (2º dia)',
    '09-23': 'Rosh Hashaná (1º dia)',
    '09-24': 'Rosh Hashaná (2º dia)',
    '10-02': 'Yom Kippur',
    '10-07': 'Sucot (1º dia)',
    '10-08': 'Sucot (2º dia)',
    '10-14': 'Shemini Atzeret',
    '10-15': 'Simchat Torah'
  },
  // 2026
  2026: {
    '04-02': 'Pessach (1º dia)',
    '04-03': 'Pessach (2º dia)',
    '04-08': 'Pessach (7º dia)',
    '04-09': 'Pessach (8º dia)',
    '05-22': 'Shavuot (1º dia)',
    '05-23': 'Shavuot (2º dia)',
    '09-12': 'Rosh Hashaná (1º dia)',
    '09-13': 'Rosh Hashaná (2º dia)',
    '09-21': 'Yom Kippur',
    '09-26': 'Sucot (1º dia)',
    '09-27': 'Sucot (2º dia)',
    '10-03': 'Shemini Atzeret',
    '10-04': 'Simchat Torah'
  },
  // 2027
  2027: {
    '04-22': 'Pessach (1º dia)',
    '04-23': 'Pessach (2º dia)',
    '04-28': 'Pessach (7º dia)',
    '04-29': 'Pessach (8º dia)',
    '06-11': 'Shavuot (1º dia)',
    '06-12': 'Shavuot (2º dia)',
    '10-02': 'Rosh Hashaná (1º dia)',
    '10-03': 'Rosh Hashaná (2º dia)',
    '10-11': 'Yom Kippur',
    '10-16': 'Sucot (1º dia)',
    '10-17': 'Sucot (2º dia)',
    '10-23': 'Shemini Atzeret',
    '10-24': 'Simchat Torah'
  },
  // 2028
  2028: {
    '04-11': 'Pessach (1º dia)',
    '04-12': 'Pessach (2º dia)',
    '04-17': 'Pessach (7º dia)',
    '04-18': 'Pessach (8º dia)',
    '05-31': 'Shavuot (1º dia)',
    '06-01': 'Shavuot (2º dia)',
    '09-21': 'Rosh Hashaná (1º dia)',
    '09-22': 'Rosh Hashaná (2º dia)',
    '09-30': 'Yom Kippur',
    '10-05': 'Sucot (1º dia)',
    '10-06': 'Sucot (2º dia)',
    '10-12': 'Shemini Atzeret',
    '10-13': 'Simchat Torah'
  }
};

// Calcula a Páscoa (algoritmo de Meeus/Jones/Butcher)
function calculateEaster(year) {
  const a = year % 19;
  const b = Math.floor(year / 100);
  const c = year % 100;
  const d = Math.floor(b / 4);
  const e = b % 4;
  const f = Math.floor((b + 8) / 25);
  const g = Math.floor((b - f + 1) / 3);
  const h = (19 * a + b - d - g + 15) % 30;
  const i = Math.floor(c / 4);
  const k = c % 4;
  const l = (32 + 2 * e + 2 * i - h - k) % 7;
  const m = Math.floor((a + 11 * h + 22 * l) / 451);
  const month = Math.floor((h + l - 7 * m + 114) / 31);
  const day = ((h + l - 7 * m + 114) % 31) + 1;
  
  return new Date(year, month - 1, day);
}

function addDays(date, days) {
  const result = new Date(date);
  result.setDate(result.getDate() + days);
  return result;
}

function formatDate(date) {
  const month = String(date.getMonth() + 1).padStart(2, '0');
  const day = String(date.getDate()).padStart(2, '0');
  return `${month}-${day}`;
}

// Função principal para obter todos os feriados de um ano
export const getHolidaysForYear = (year) => {
  const holidays = {
    brazilian: { ...BRAZILIAN_FIXED_HOLIDAYS },
    jewish: JEWISH_HOLIDAYS[year] || {}
  };
  
  // Adiciona feriados móveis brasileiros
  const mobileHolidays = getBrazilianMobileHolidays(year);
  Object.assign(holidays.brazilian, mobileHolidays);
  
  return holidays;
};

// Verifica se uma data é feriado
export const getHolidayInfo = (year, month, day) => {
  const holidays = getHolidaysForYear(year);
  const dateKey = `${String(month).padStart(2, '0')}-${String(day).padStart(2, '0')}`;
  
  const result = {
    isBrazilianHoliday: false,
    isJewishHoliday: false,
    brazilianName: null,
    jewishName: null
  };
  
  if (holidays.brazilian[dateKey]) {
    result.isBrazilianHoliday = true;
    result.brazilianName = holidays.brazilian[dateKey];
  }
  
  if (holidays.jewish[dateKey]) {
    result.isJewishHoliday = true;
    result.jewishName = holidays.jewish[dateKey];
  }
  
  return result;
};
